const dataSlides = [
    {
        id: 1,
        titleTop: 'The all natural way',
        titleBottom: 'to love yourself',
        img: 'slide1'
    },
    {
        id: 2,
        titleTop: 'Treat yourself to an',
        titleBottom: 'amazing spa day',
        img: 'slide2'
    },
    {
        id: 3,
        titleTop: 'Quality face mask',
        titleBottom: 'for sensitive skin',
        img: 'slide3'
    },
    {
        id: 4,
        titleTop: 'Relax and enjoy our',
        titleBottom: 'weekend offers',
        img: 'slide4'
    }
]
export default dataSlides;